import { BASE_VARIANT } from '../constant';

export const SLIDER_MARKER_GAP = 20;
export const SLIDER_MARKER_SIZE = 16;

export const SLIDER_THUMB_SIZE = 14;

export const SLIDER_TRACK_MARKER_GAP = 32;
export const SLIDER_TRACK_MARKER_SIZE = 4;

export const SLIDER_VARIANT = {
  PRIMARY: BASE_VARIANT.PRIMARY,
  SECONDARY: BASE_VARIANT.SECONDARY,
  FRAME_SLIDER: 'frameSlider',
  FRAME_TRACK_SLIDER: 'frameTrackSlider',
  CACHED_FRAME_TRACK_SLIDER: 'cachedFrameTrackSlider',
} as const;
